import React from "react";
import { t } from "../../../../utils/i18n";

const Description = ({ transfer, canViewCardTransactionDetails }) => {
  const {
    source_currency,
    destination_currency,
    source_wallet_id,
    destination_wallet_id,
    default_crypto_wallet_id,
    is_destination_user_wallet,
    is_destination_store_wallet,
    destination_wallet_user_name,
    destination_wallet_user_email,
    source_wallet_user_name,
    source_wallet_user_email,
    destination_wallet_store_name,
    destination_wallet_store_address,
    destination_wallet_store_email,
    blockchain_tx,
    blockchain_address,
    user_email,
    user_name,
    is_blockchain_deposit,
    is_card_load,
    is_card_request,
    wallet_transfer_type,
  } = transfer;

  if (is_card_load) {
    return wallet_transfer_type === "card_load_bananacrystal_fee" ? (
      <span>{t("account.activities.card_loading_fee")}</span>
    ) : (
      <span>{t("account.activities.card_funding_fee")}</span>
    );
  }

  if (is_card_request) {
    return <span>{t("account.activities.card_request_fee")}</span>;
  }

  if (source_currency !== destination_currency) return <></>;

  if (is_destination_store_wallet) {
    return (
      <>
        {destination_wallet_store_name}
        <br /> {destination_wallet_store_address}
        <br /> {destination_wallet_store_email}
      </>
    );
  } else if (is_blockchain_deposit) {
    return <>{t("account.activities.blockchain_deposit")}</>;
  } else if (destination_wallet_id === default_crypto_wallet_id) {
    return (
      destination_wallet_id && (
        <>
          {source_wallet_user_name} <br />
          {source_wallet_user_email}
        </>
      )
    );
  } else if (
    !source_wallet_id ||
    destination_wallet_id === default_crypto_wallet_id
  ) {
    return source_wallet_id ? (
      <>
        {user_name} <br />
        {user_email}
      </>
    ) : (
      <>
        {t("account.activities.external_wallet")}
        <br />({source_currency}){blockchain_tx}
      </>
    );
  } else if (is_destination_user_wallet) {
    return (
      <>
        {destination_wallet_user_name}
        <br /> {destination_wallet_user_email}
      </>
    );
  } else {
    return (
      <>
        {t("account.activities.external_wallet")}
        <br /> ({source_currency} {blockchain_address})
      </>
    );
  }
};

export default Description;
